import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import HeroSection from "./components/HeroSection";
import LinkSection from "./components/LinkSection";
import Footer from "@/components/feature/Footer";

export default function Home() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash === "#links") {
      const el = document.getElementById("links");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);

  return (
    <main className="min-h-screen">
      <article>
        <HeroSection />
        <LinkSection />
      </article>
      <Footer />
    </main>
  );
}